import { render } from "./ow-work-types.vue?vue&type=template&id=207af652"
import script from "./ow-work-types.vue?vue&type=script&lang=js"
export * from "./ow-work-types.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__